import builder from '../builder';
import ModernTV3DSync from '../../streamline-icons/bold/modern-tv-3d-sync.svg';

export default builder('IconModernTV3DSyncBold', ModernTV3DSync);
